import * as loc from 'date-fns/locale';

export async function loadDateFnsLocale(localeCode) { return loc[localeCode]; };
